"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFields = void 0;
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
function createCustomField(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'POST',
            endpoint: `${workspaceId}/customFields`,
            body: rest,
        });
    });
}
function getCustomField(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, customFieldId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'GET',
            endpoint: `${workspaceId}/customFields/${customFieldId}`,
        });
    });
}
function listCustomFields(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, options = {}, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/customFields?${(0, util_1.formatParamsForHttp)(options)}`,
        });
    });
}
function updateCustomField(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, customField, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'PATCH',
            endpoint: `${workspaceId}/customFields/${customField.id}`,
            body: customField,
        });
    });
}
function listCustomFieldTypes(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/customFieldTypes`,
        });
    });
}
function listCustomFieldColors(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/customFieldColors`,
        });
    });
}
function listCustomFieldValues(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, customFieldId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'GET',
            endpoint: `${workspaceId}/customFields/${customFieldId}/values`,
        });
    });
}
function deleteCustomField(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, customFieldId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'DELETE',
            endpoint: `${workspaceId}/customFields/${customFieldId}`,
        });
    });
}
/**
 * Move custom fields between 2 other CFs or before/after a CF
 * @param idsToMove Custom Field ids to move (in the order that they appear in settings)
 * @param betweenIds.moveBeforeId CF id to move idsToMove before (end)
 * @param betweenIds.moveAfterId CF id to move idsToMove after (start)
 */
function updateCustomFieldPositions(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/customFields/position`,
            method: 'PATCH',
            body: rest,
        });
    });
}
exports.CustomFields = {
    createCustomField,
    getCustomField,
    listCustomFields,
    updateCustomField,
    listCustomFieldTypes,
    listCustomFieldColors,
    listCustomFieldValues,
    deleteCustomField,
    updateCustomFieldPositions,
};
//# sourceMappingURL=customFields.js.map